import { render, staticRenderFns } from "./AdultBullScreening.vue?vue&type=template&id=54080336&scoped=true&"
import script from "./AdultBullScreening.vue?vue&type=script&lang=js&"
export * from "./AdultBullScreening.vue?vue&type=script&lang=js&"
import style0 from "./AdultBullScreening.vue?vue&type=style&index=0&id=54080336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54080336",
  null
  
)

export default component.exports